import BaseURL from 'constants/BaseURL';
import getKeywordInText from 'utils/getKeywordInText';
import Keywords from 'constants/Keywords';

export default (text, linekeywords) => {
  const sanitizedText = text.replace(/__/g, '____');
  const keywordInText = getKeywordInText(sanitizedText, linekeywords);

  const splitTextWithLineKeyword = keywordInText.text.split('__');
  const textHasLineKeyword = splitTextWithLineKeyword.length > 2;

  return Keywords.Topic.reduce((topicSelectedText, topic) => {
    const topicWord = Object.keys(topic)[0];
    const lineSelectedWord = textHasLineKeyword
      ? splitTextWithLineKeyword[1].toLowerCase()
      : '';

    if (textHasLineKeyword && lineSelectedWord.includes(topicWord)) {
      return topicSelectedText.replace(
        `__${splitTextWithLineKeyword[1]}__`,
        '__```' + splitTextWithLineKeyword[1] + '```__'
      );
    }

    return getKeywordInText(topicSelectedText, [topicWord], '```').text;
  }, keywordInText.text).replace(/____/g, '');
};
